import {
    STORE_LAST_REMOVED_ITEM,
    DELETE_LAST_REMOVED_ITEM,
} from '../actionTypes/SavedListActionTypes';

export default function lastRemovedListItemReducer(state = {}, action) {
    switch (action.type) {
        case STORE_LAST_REMOVED_ITEM:
            return action.payload;
        case DELETE_LAST_REMOVED_ITEM:
            return {};
        default:
            return state;
    }
}
